import {
  BLOCK_TYPE_CONTAINER,
  BLOCK_TYPE_CONTENT
} from './block_type_definitions.js';

import {
  BLOCK_SUBTYPE_GRID_HERO_LEFT_ALIGNED,
  BLOCK_SUBTYPE_GRID_HERO_MIDDLE_ALIGNED,
  BLOCK_SUBTYPE_IMAGE,
  BLOCK_SUBTYPE_GRID_IMAGE_AND_TEXT_FULL_BLEED,
  BLOCK_SUBTYPE_GRID_IMAGE_AND_TEXT_BORDERED,
  BLOCK_SUBTYPE_GRID_VIDEO_AND_TEXT_FULL_BLEED,
  BLOCK_SUBTYPE_GRID_VIDEO_AND_TEXT_BORDERED,
  BLOCK_SUBTYPE_GRID,
  BLOCK_SUBTYPE_GRID_BIO_ROUNDED,
  BLOCK_SUBTYPE_GRID_BIO_ROUNDED_SINGLE,
  BLOCK_SUBTYPE_GRID_BIO_STANDARD,
  BLOCK_SUBTYPE_GRID_BIO_STANDARD_SINGLE,
  BLOCK_SUBTYPE_SUBPAGE
} from './block_subtype_definitions';


const CATEGORY_TAG_BLANK = 'blank';
const CATEGORY_TAG_TEXT =  'text';
const CATEGORY_TAG_PRESENTATION = 'presentation';
const CATEGORY_TAG_VIDEO = 'video';
const CATEGORY_TAG_FILES = 'files';
const CATEGORY_TAG_EMBEDS = 'embeds';
const CATEGORY_TAG_BIO = 'bio';
const CATEGORY_TAG_TILES = 'tiles';
const CATEGORY_TAG_CREATORS = 'creators';
const CATEGORY_TAG_HERO = 'hero';
const CATEGORY_TAG_IMAGE = 'image';
const CATEGORY_TAG_IMAGE_BIO = 'image bio';
const CATEGORY_TAG_GRID = 'grid';
const CATEGORY_TAG_TABS = 'tabs';

export {
  // TYPES
  BLOCK_TYPE_CONTAINER,
  BLOCK_TYPE_CONTENT,

  // SUBTYPES
  BLOCK_SUBTYPE_GRID_HERO_LEFT_ALIGNED,
  BLOCK_SUBTYPE_GRID_HERO_MIDDLE_ALIGNED,
  BLOCK_SUBTYPE_IMAGE,
  BLOCK_SUBTYPE_GRID_IMAGE_AND_TEXT_FULL_BLEED,
  BLOCK_SUBTYPE_GRID_IMAGE_AND_TEXT_BORDERED,
  BLOCK_SUBTYPE_GRID_VIDEO_AND_TEXT_FULL_BLEED,
  BLOCK_SUBTYPE_GRID_VIDEO_AND_TEXT_BORDERED,
  BLOCK_SUBTYPE_GRID,
  BLOCK_SUBTYPE_GRID_BIO_ROUNDED,
  BLOCK_SUBTYPE_GRID_BIO_ROUNDED_SINGLE,
  BLOCK_SUBTYPE_GRID_BIO_STANDARD,
  BLOCK_SUBTYPE_GRID_BIO_STANDARD_SINGLE,
  BLOCK_SUBTYPE_SUBPAGE,

  // TAGS
  CATEGORY_TAG_BLANK,
  CATEGORY_TAG_TEXT,
  CATEGORY_TAG_PRESENTATION,
  CATEGORY_TAG_VIDEO,
  CATEGORY_TAG_FILES,
  CATEGORY_TAG_EMBEDS,
  CATEGORY_TAG_BIO,
  CATEGORY_TAG_TILES,
  CATEGORY_TAG_CREATORS,
  CATEGORY_TAG_HERO,
  CATEGORY_TAG_IMAGE,
  CATEGORY_TAG_IMAGE_BIO,
  CATEGORY_TAG_GRID,
  CATEGORY_TAG_TABS
};
